import React, { useEffect, useState } from 'react';
import NftCard from "./nftCard";
import { getAllNFTs } from "../utils/commonInteractor";
import useLoader from "../hooks/useLoader";
import classNames from 'classnames';
import { Link } from 'react-router-dom';

let allNFTs = [];
function Storefront(props) {
    const [loader, showLoader, hideLoader] = useLoader();
    const [data, setData] = useState([]);
    const [catFilters, setCatFilters] = useState([]);

    const [searchInput, setSearchInput] = useState('');


    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        let NFTs = [...allNFTs];
        if (catFilters) NFTs = NFTs.filter(nft => nft.category === catFilters);
        getPageData(NFTs)
    }, [catFilters])

    const handleChangeCategory = (filterType) => {
       filterType === catFilters ? setCatFilters('') : setCatFilters(filterType)
    }

    function getPageData(NFTs) {
        if (NFTs.length) {
            setData(NFTs);
        } else {
            setData([]);
        }
    }

    const init = async () => {
        showLoader('Loading Items....')
        const NFTs = await getAllNFTs();
        allNFTs = [...NFTs]
        getPageData(allNFTs);
        hideLoader()
    }
    const handleSearch = () => {
        let NFTs = [...allNFTs];
        NFTs = NFTs.filter(nft => nft.name && nft.name.toLowerCase().includes(searchInput.toLowerCase()));
        getPageData(NFTs)
    }

    return (
        <>
            {loader}
            <div className="hero-wrap">
                <div className="container hero-container">
                    <div className="row hero-row">
                        <div className="col-md-6">
                            <div className="hero-content">
                                <h2>Marketplace <br /> of the <br /> Future</h2>
                                <p>
                                    Join the future of NFTs and become <br /> part of a revolution that’s going to take <br /> the
                                    world!
                                </p>
                                <div className="hero-btns">
                                    <Link to={"/create"} className="hero-btn btns">Get Started</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 position-relative">
                            <img className="hero-video" src="/assets/img/main.jpg"/>
                            {/* <video className="hero-video" autoPlay playsInline loop muted controls>
                                <source src="assets/video/video.mp4" type="video/mp4" />
                            </video> */}
                        </div>
                    </div>
                    <a href="#!" className="scroll-bottom col-md-6 m-auto text-center" data-scroll="top-collectors">
                        <div>
                            <p>Scroll down for more</p>
                            <img src="assets/img/icon/angle-down-y.png" alt="" />
                        </div>
                    </a>
                </div>
            </div>
            <div className="explore-wrp">
                <div className="container">
                    <div className="fox-heading text-center">
                        <h4>Explore</h4>
                    </div>
                    <div className="filter-wrp">
                        <div className="row align-items-end">
                            <div className="col-xl-8">
                                <div className="filter-left">
                                    <div className="filter-search">
                                        <input onBlur={handleSearch} value={searchInput} onChange={(e) => setSearchInput(e.target.value)} type="text" placeholder="Searching for..." />
                                        <a role="button" onClick={handleSearch} className="search-btn"><img src="assets/img/icon/search.png" alt="" /></a>
                                    </div>
                                    <div className="categories-wrp">
                                        <a role={"button"} onClick={() => handleChangeCategory('ART')} className={classNames('categories-item', { 'active': catFilters === 'ART' })}><img src="/assets/img/icon/categories.png" alt="" />Art</a>
                                        <a role={"button"} onClick={() => handleChangeCategory('PHOTO')} className={classNames('categories-item', { 'active': catFilters === 'PHOTO' })}><img src="/assets/img/icon/categories.png" alt="" />Photo</a>
                                        <a role={"button"} onClick={() => handleChangeCategory('GIF')} className={classNames('categories-item', { 'active': catFilters === 'GIF' })}><img src="/assets/img/icon/categories.png" alt="" />GIF</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="explore-nft-container">
                        <div className="row" id="nft-container">
                            {
                                data.map(card => (
                                    <NftCard nft={card} key={card.tokenId} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Storefront;
